// extracted by mini-css-extract-plugin
var _1 = "NumberedPagination__pagination";
var _2 = "NumberedPagination__pagination__link";
var _3 = "NumberedPagination__pagination__link--selected";
var _4 = "NumberedPagination__pagination__navigation-link";
var _5 = "NumberedPagination__pagination__navigation-link--disabled";
export { _1 as "pagination", _2 as "pagination__link", _3 as "pagination__link--selected", _4 as "pagination__navigation-link", _5 as "pagination__navigation-link--disabled" }
